import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../api/client";

// Admin: one broadcast — the post, the audience, delivery, clicks and what followed (2026-10-20)
function when(v: string | null) {
  if (!v) return "—";
  return new Date(v).toLocaleString("ru-RU", { day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit" });
}

function pct(part: number, whole: number) {
  return whole > 0 ? ` (${Math.round((part / whole) * 100)}%)` : "";
}

function rub(v: number) {
  return `${Math.round(v).toLocaleString("ru-RU")} ₽`;
}

function duration(s: number | null) {
  if (s === null || s === undefined) return "—";
  return s < 60 ? `${s} с` : `${Math.floor(s / 60)} мин ${s % 60} с`;
}

function who(u: any) {
  const name = u.username ? `@${u.username}` : u.first_name || `TG: ${u.telegram_id}`;
  const href = u.username ? `https://t.me/${u.username}` : `tg://user?id=${u.telegram_id}`;
  return <a href={href} target="_blank" rel="noopener noreferrer" style={styles.link}>{name}</a>;
}

function Row({ label, value }: { label: string; value: any }) {
  return (
    <div style={styles.row}>
      <span style={styles.rowLabel}>{label}</span>
      <span style={styles.rowValue}>{value}</span>
    </div>
  );
}

const OP_TITLES: Record<string, string> = { button: "кнопка", content: "текст/фото", delete: "удаление у всех" };

// 2026-10-28: change a sent broadcast — the button here, the text / photo in the bot, delete for everyone (48 h)
function EditBox({ b, reload }: { b: any; reload: () => void }) {
  const e = b.edit || {};
  const [open, setOpen] = useState(false);
  const [kind, setKind] = useState<string>(b.button_kind || "none");
  const [text, setText] = useState<string>(b.button_kind === "url" ? b.button_text || "" : "");
  const [url, setUrl] = useState<string>(b.button_kind === "url" ? b.button_url || "" : "");
  const [askDelete, setAskDelete] = useState(false);
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);

  const run = async (payload: any, done: string) => {
    setBusy(true);
    setMsg("Запускаю…");
    try {
      const r: any = await api.post(`/admin/bc/${b.id}/edit`, payload);
      setMsg(`${done} у ${r.data.targets} получателей. Сводка придёт в бот.`);
      setOpen(false);
      setAskDelete(false);
      setTimeout(reload, 4000);
    } catch (err: any) {
      setMsg(err?.response?.data?.detail?.text || "Не получилось");
    } finally {
      setBusy(false);
    }
  };

  const editText = () => {
    const link = `https://t.me/avigatr_bot?start=bcedit_${b.id}`;
    const tg = (window as any).Telegram?.WebApp;
    if (tg?.openTelegramLink) tg.openTelegramLink(link);
    else window.open(link, "_blank");
  };

  if (e.deleted) {
    return <div style={styles.box}><div style={styles.boxTitle}>Изменение</div><div style={styles.hint}>🗑 Рассылка удалена у всех получателей.</div>{history(e)}</div>;
  }
  if (!e.editable) {
    return (
      <div style={styles.box}>
        <div style={styles.boxTitle}>Изменение</div>
        <div style={styles.hint}>{b.status === "SENDING" ? "Рассылка ещё отправляется — изменить можно после окончания." : "Изменять и удалять можно рассылки, отправленные после 28.10.2026."}</div>
      </div>
    );
  }
  const tme = /^(https?:\/\/(t|telegram)\.me\/|tg:\/\/)/.test(url.trim());
  return (
    <div style={styles.box}>
      <div style={styles.boxTitle}>Изменение · {e.messages} сообщений</div>
      {e.running && <div style={{ ...styles.hint, marginBottom: "8px" }}>⏳ Идёт изменение ({OP_TITLES[e.running.op] || e.running.op})… <span style={styles.linkBtn} onClick={reload}>обновить</span></div>}

      {!open ? (
        <button style={styles.ghostBtn} disabled={busy} onClick={() => setOpen(true)}>🔘 Изменить кнопку</button>
      ) : (
        <div style={styles.form}>
          <div style={styles.kinds}>
            {[["none", "Без кнопки"], ["tariffs", "Тарифы"], ["url", "Ссылка"]].map(([k, t]) => (
              <button key={k} style={kind === k ? styles.kindOn : styles.kindOff} onClick={() => setKind(k)}>{t}</button>
            ))}
          </div>
          {kind === "url" && (
            <>
              <input style={styles.input} placeholder="Текст кнопки" maxLength={64} value={text} onChange={(ev) => setText(ev.target.value)} />
              <input style={styles.input} placeholder="https://…" value={url} onChange={(ev) => setUrl(ev.target.value)} />
              {tme && <div style={styles.hint}>Ссылка Telegram откроется сразу, без браузера; нажатия по ней не считаются.</div>}
            </>
          )}
          {kind === "tariffs" && <div style={styles.hint}>«💎 Оформить подписку» — тарифы в Мини-приложении.</div>}
          <div style={styles.kinds}>
            <button style={styles.actionBtn} disabled={busy || (kind === "url" && (!text.trim() || !/^https?:\/\/\S{3,}/.test(url.trim())))}
              onClick={() => run({ op: "button", kind, text: text.trim(), url: url.trim() }, "Меняю кнопку")}>Сохранить у всех</button>
            <button style={styles.ghostBtn} onClick={() => setOpen(false)}>Отмена</button>
          </div>
        </div>
      )}

      <button style={{ ...styles.ghostBtn, marginTop: "8px" }} disabled={busy || !e.content_editable} onClick={editText}>📝 Изменить текст / фото</button>
      <div style={{ ...styles.hint, marginTop: "4px" }}>
        {e.content_editable ? <>Откроется бот: пришлите новый пост и подтвердите. Или напишите боту <code>/bcedit {b.id}</code>.</> : "Такой вид поста Telegram изменить не даёт."}
      </div>

      {e.can_delete && (!askDelete ? (
        <button style={{ ...styles.dangerBtn, marginTop: "10px" }} disabled={busy} onClick={() => setAskDelete(true)}>🗑 Удалить у всех</button>
      ) : (
        <div style={{ ...styles.form, marginTop: "10px" }}>
          <div style={styles.note}>Удалить пост у {e.messages} получателей? Вернуть будет нельзя.</div>
          <div style={styles.kinds}>
            <button style={styles.dangerBtn} disabled={busy} onClick={() => run({ op: "delete" }, "Удаляю")}>Да, удалить</button>
            <button style={styles.ghostBtn} onClick={() => setAskDelete(false)}>Отмена</button>
          </div>
        </div>
      ))}
      <div style={{ ...styles.hint, marginTop: "4px" }}>
        {e.can_delete ? `Удалить у всех можно до ${when(e.delete_until)} (Telegram даёт 48 ч).` : "Удалить у всех уже нельзя: Telegram даёт на это 48 ч."}
      </div>
      {msg && <div style={{ ...styles.note, marginTop: "8px" }}>{msg}</div>}
      {history(e)}
    </div>
  );
}

function history(e: any) {
  if (!e.history || e.history.length === 0) return null;
  return (
    <div style={{ marginTop: "8px" }}>
      {e.history.slice().reverse().map((h: any, i: number) => (
        <div key={i} style={styles.hint}>
          {when(h.at)} · {OP_TITLES[h.op] || h.op} · готово {h.ok}{h.gone ? `, уже нет ${h.gone}` : ""}{h.blocked ? `, заблокировали ${h.blocked}` : ""}{h.failed ? `, ошибки ${h.failed}` : ""}
        </div>
      ))}
    </div>
  );
}

export default function AdminBroadcastDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [b, setB] = useState<any>(null);
  const [error, setError] = useState(false);
  const [sent, setSent] = useState("");

  const load = () => api.get(`/admin/bc/${id}`).then((r: any) => setB(r.data)).catch(() => setError(true));
  useEffect(() => {
    load();
  }, [id]);

  const sendMe = async () => {
    setSent("Отправляю…");
    try {
      const r: any = await api.post(`/admin/bc/${id}/send-me`);
      setSent(r.data.ok ? "Пост отправлен вам в бот" : "Не получилось: пост удалён из чата с ботом?");
    } catch {
      setSent("Не получилось отправить");
    }
  };

  return (
    <div style={styles.container}>
      <button style={styles.backBtn} onClick={() => navigate("/admin/broadcasts")}>← Рассылки</button>
      {error && <div style={styles.hint}>Не удалось загрузить рассылку</div>}
      {!b && !error && <div style={styles.center}><div style={styles.spinner} /></div>}
      {b && (
        <>
          <h1 style={styles.title}>Рассылка #{b.id}</h1>

          <div style={styles.box}>
            <div style={styles.boxTitle}>Пост</div>
            <Row label="Тип" value={b.content} />
            <Row label="Кнопка" value={b.button_kind === "url" ? `«${b.button_text}» → ${b.button_url}` : b.button} />
            <div style={styles.post}>{b.text}</div>
            <button style={styles.actionBtn} onClick={sendMe}>📩 Прислать пост мне в бот</button>
            {sent && <div style={{ ...styles.hint, marginTop: "6px" }}>{sent}</div>}
          </div>

          <EditBox b={b} reload={load} />

          <div style={styles.box}>
            <div style={styles.boxTitle}>Аудитория и доставка</div>
            <Row label="Аудитория" value={b.audience} />
            <Row label="Запущена" value={when(b.created_at)} />
            <Row label="Отправка заняла" value={b.status === "SENDING" ? "идёт…" : duration(b.duration_s)} />
            <Row label="Получателей" value={b.total} />
            <Row label="Доставлено" value={`${b.ok}${pct(b.ok, b.total)}`} />
            <Row label="Заблокировали бота при отправке" value={b.blocked} />
            <Row label="Ошибки" value={b.failed} />
          </div>

          {!b.tracked ? (
            <div style={styles.box}>
              <div style={styles.hint}>Подробности по получателям (нажатия, оплаты) собираются для рассылок, отправленных после 20.10.2026.</div>
            </div>
          ) : (
            <>
              <div style={styles.box}>
                <div style={styles.boxTitle}>Отклик</div>
                {b.button_kind === "none" ? (
                  <div style={styles.hint}>Кнопки не было — нажатия не считаются.</div>
                ) : (
                  <>
                    <Row label="Нажали кнопку (людей)" value={`${b.clicked}${pct(b.clicked, b.ok)}`} />
                    <Row label="Всего нажатий" value={b.clicks} />
                    {b.button_kind === "url" && /^(https?:\/\/(t|telegram)\.me\/|tg:\/\/)/.test(b.button_url || "") && (
                      <div style={{ ...styles.hint, marginTop: "4px" }}>Кнопка ведёт в Telegram и открывается напрямую — такие нажатия не считаются.</div>
                    )}
                  </>
                )}
              </div>

              <div style={styles.box}>
                <div style={styles.boxTitle}>Результат за {b.result_days} дней{b.result_final ? "" : " (ещё идёт)"}</div>
                <Row label="Оплатили (людей)" value={`${b.payers.length}${pct(b.payers.length, b.ok)}`} />
                {b.button_kind !== "none" && <Row label="…из них после нажатия кнопки" value={b.paid_after_click} />}
                <Row label="Выручка" value={rub(b.revenue_rub)} />
                {Object.keys(b.by_plan).length > 0 && (
                  <Row label="По тарифам" value={Object.entries(b.by_plan).map(([k, v]) => `${k} ${v}`).join(", ")} />
                )}
                <Row label="Начали пробный" value={b.trials} />
                <Row label="Запустили поиск" value={b.searches} />
                <Row label={`Заблокировали бота за ${b.block_hours} ч`} value={`${b.blocked_after}${pct(b.blocked_after, b.total)}`} />
                <div style={{ ...styles.hint, marginTop: "6px" }}>Считается до {when(b.result_until)}.</div>
              </div>

              {b.payers.length > 0 && (
                <div style={styles.box}>
                  <div style={styles.boxTitle}>Кто оплатил</div>
                  {b.payers.map((p: any) => (
                    <div key={p.user_id} style={styles.person}>
                      {who(p)} <span style={styles.hint}>· {p.plan} · {rub(p.amount_rub)} · {when(p.paid_at)}{p.after_click ? " · после нажатия" : ""}</span>
                    </div>
                  ))}
                </div>
              )}

              {b.clickers.length > 0 && (
                <div style={styles.box}>
                  <div style={styles.boxTitle}>Кто нажал кнопку</div>
                  {b.clickers.map((c: any) => (
                    <div key={c.user_id} style={styles.person}>
                      {who(c)} <span style={styles.hint}>· {when(c.clicked_at)}</span>
                    </div>
                  ))}
                </div>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: { padding: "16px", maxWidth: "480px", margin: "0 auto" },
  backBtn: { background: "none", border: "none", color: "var(--tg-theme-link-color, #2481cc)", fontSize: "14px", cursor: "pointer", padding: 0, marginBottom: "12px" },
  title: { fontSize: "22px", fontWeight: 700, margin: "0 0 12px 0", color: "var(--tg-theme-text-color, #000)" },
  center: { display: "flex", justifyContent: "center", padding: "40px 0" },
  spinner: { width: "28px", height: "28px", border: "3px solid #e5e7eb", borderTop: "3px solid #3b82f6", borderRadius: "50%", animation: "spin 1s linear infinite" },
  hint: { fontSize: "12px", color: "var(--tg-theme-hint-color, #666)" },
  box: { backgroundColor: "var(--tg-theme-secondary-bg-color, #fff)", borderRadius: "12px", padding: "12px", marginBottom: "10px", boxShadow: "0 1px 3px rgba(0,0,0,0.08)" },
  boxTitle: { fontSize: "13px", fontWeight: 700, color: "var(--tg-theme-text-color, #000)", marginBottom: "8px", textTransform: "uppercase" },
  row: { display: "flex", justifyContent: "space-between", gap: "12px", padding: "3px 0", fontSize: "13px" },
  rowLabel: { color: "var(--tg-theme-hint-color, #666)" },
  rowValue: { color: "var(--tg-theme-text-color, #000)", fontWeight: 600, textAlign: "right", wordBreak: "break-word" },
  post: { fontSize: "13px", color: "var(--tg-theme-text-color, #000)", whiteSpace: "pre-wrap", backgroundColor: "var(--tg-theme-bg-color, #f4f4f5)", borderRadius: "10px", padding: "10px", margin: "8px 0" },
  actionBtn: { width: "100%", padding: "10px", borderRadius: "10px", border: "none", backgroundColor: "var(--tg-theme-button-color, #2481cc)", color: "var(--tg-theme-button-text-color, #fff)", fontSize: "14px", cursor: "pointer" },
  person: { fontSize: "13px", padding: "4px 0", color: "var(--tg-theme-text-color, #000)" },
  link: { color: "var(--tg-theme-link-color, #2481cc)", textDecoration: "none", fontWeight: 600 },
  ghostBtn: { width: "100%", padding: "10px", borderRadius: "10px", border: "1px solid var(--tg-theme-button-color, #2481cc)", backgroundColor: "transparent", color: "var(--tg-theme-button-color, #2481cc)", fontSize: "14px", cursor: "pointer" },
  dangerBtn: { width: "100%", padding: "10px", borderRadius: "10px", border: "none", backgroundColor: "#ef4444", color: "#fff", fontSize: "14px", cursor: "pointer" },
  form: { display: "flex", flexDirection: "column", gap: "8px", padding: "10px", borderRadius: "10px", backgroundColor: "var(--tg-theme-bg-color, #f4f4f5)" },
  kinds: { display: "flex", gap: "6px" },
  kindOn: { flex: 1, padding: "8px 4px", borderRadius: "8px", border: "none", backgroundColor: "var(--tg-theme-button-color, #2481cc)", color: "var(--tg-theme-button-text-color, #fff)", fontSize: "13px", cursor: "pointer" },
  kindOff: { flex: 1, padding: "8px 4px", borderRadius: "8px", border: "1px solid rgba(127,127,127,0.3)", backgroundColor: "transparent", color: "var(--tg-theme-text-color, #000)", fontSize: "13px", cursor: "pointer" },
  input: { width: "100%", boxSizing: "border-box", padding: "9px 10px", borderRadius: "8px", border: "1px solid rgba(127,127,127,0.3)", backgroundColor: "var(--tg-theme-secondary-bg-color, #fff)", color: "var(--tg-theme-text-color, #000)", fontSize: "14px" },
  note: { fontSize: "13px", color: "var(--tg-theme-text-color, #000)", fontWeight: 600 },
  linkBtn: { color: "var(--tg-theme-link-color, #2481cc)", cursor: "pointer" },
};
